var parseKnowledge = {


    // Method for parsing FAQ article html for accordion-style FAQ experience
    // html can contain a header, footer, and list of question + answer pairs
    // as defined in headless UI
    checkForAndProcessArticleFaqs(articleContent) {
        let result = []

        // create a temporary html element to parse article content
        var el = document.createElement('html');
        el.innerHTML = articleContent.content;
        
        let faqArticleHeaderHtml = el.getElementsByClassName('eh-faq-article-header');
        if (faqArticleHeaderHtml.length > 0) articleContent.faqHeader = faqArticleHeaderHtml[0].innerHTML;
        let faqArticleFooterHtml = el.getElementsByClassName('eh-faq-article-footer');
        if (faqArticleFooterHtml.length > 0) articleContent.faqFooter = faqArticleFooterHtml[0].innerHTML;

        let faqsList = el.getElementsByClassName('eh-faq-wrapper');
        for (let faqHtml of faqsList) {

            let faqId = faqHtml.id;
            let questionHtml = faqHtml.getElementsByClassName('eh-faq-question')[0].innerHTML;
            let answerHtml = faqHtml.getElementsByClassName('eh-faq-answer')[0].innerHTML;
            result.push({
                id: faqId,
                question: questionHtml,
                answer: answerHtml
            })
        }

        if (result.length > 0) articleContent.faqs = result;
        return articleContent;
    }

}

export default parseKnowledge;